module.exports = __webpack_public_path__ + "img/StealthLook.5396740a.png";